import { HTMLAttributes, forwardRef } from 'react';

export interface VStackProps extends HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
}

export const VStack = forwardRef<HTMLDivElement, VStackProps>(
  ({ children = null, className, ...props }, ref) => {
    return (
      <div ref={ref} className={`flex flex-col ${className ?? ''}`} {...props}>
        {children}
      </div>
    );
  }
);
